import * as React from "react";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { Col, ConfigProvider, Row } from "antd";
import { StudentEventCard } from "../Components/Events";
import usePortalService from "../services/PortalService";
import { Navbar } from "../Components/Navbars/Navbar";
import { EventShortProps } from "../types";

export const StudentEvents = () => {

	const { eventList } = usePortalService();

	const [events, setEvents] = useState<null | EventShortProps[]>([]);

	useEffect(() => {
		eventList().then(result => {
			if (result.success) {
				setEvents(result.events.items)
			}
		})
	}, [])

	return (
		<ConfigProvider
			theme={{
				token: {
					screenXXLMin: 1850,
					screenXXL: 1850,
					screenXLMin: 1350,
					screenXL: 1350,
					screenLGMax: 1000,
					screenLG: 1000
				}
			}}
		>
			<div className="events-page">
				<Navbar />
				<div className="events-container">
					<h1 style={{ marginBottom: "15px" }}>События</h1>
					<Row gutter={[20, 40]} justify="start" wrap={true}>
						{events && events.map(event =>
							<Col xxl={6} xl={8} lg={12} md={24} key={event.id}>
								<StudentEventCard event={event} />
							</Col>
						)}
					</Row>
				</div>
			</div>
		</ConfigProvider>
	)
}